import { format } from 'date-fns'

export const lastTransactionTime = (lastTransaction: string) => {
  const now = new Date()
  const lastTransactionDate = new Date(lastTransaction)

  const nowMilliseconds = now.getTime()
  const lastTransactionDateMilliseconds = lastTransactionDate.getTime()

  const diffInMilliseconds = nowMilliseconds - lastTransactionDateMilliseconds
  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60))
  const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60))

  if (diffInMinutes < 60) {
    return `há ${diffInMinutes} minuto(s)`
  }
  if (diffInHours < 24) {
    return `há ${diffInHours} hora(s)`
  }
  if (diffInHours < 48) {
    return 'Ontem'
  }

  return format(lastTransactionDate, 'dd/MM/yyyy')
}
